import React, { useState, useEffect } from 'react'
import CreateLessonModal from './CreateLessonModal'
import LessonsGrid from './LessonsGrid'
import { formatError } from '../utils/errorHandler'
import './Lessons.css'

function Lessons({ role }) {
  const [lessons, setLessons] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [refreshKey, setRefreshKey] = useState(0)
  const [showCreateModal, setShowCreateModal] = useState(false)

  useEffect(() => {
    loadLessons()
  }, [searchTerm, refreshKey])

  const loadLessons = async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await import('../services/lessonsApi').then(m => 
        m.listLessons(searchTerm, 100)
      )
      // Backend returns array directly, not wrapped in { lessons: [...] }
      setLessons(Array.isArray(data) ? data : (data.lessons || []))
    } catch (err) {
      setError(formatError(err))
    } finally {
      setLoading(false)
    }
  }

  const handleLessonCreated = () => {
    setRefreshKey(prev => prev + 1)
  }

  const handleLessonUpdated = () => {
    setRefreshKey(prev => prev + 1)
  }

  return (
    <div className="lessons">
      <div className="lessons-header">
        <h2>Lessons Management</h2>
      </div>

      <div className="lessons-controls">
        <div className="lessons-search">
          <input
            type="text"
            placeholder="Search lessons..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        {role === 'admin' && (
          <button
            className="create-btn"
            onClick={() => setShowCreateModal(true)}
          >
            <span className="create-btn-icon">+</span>
            Create New Lesson
          </button>
        )}
      </div>

      {error && <div className="error-message">Error: {error}</div>}

      {loading ? (
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Loading lessons...</p>
        </div>
      ) : (
        <LessonsGrid
          lessons={lessons}
          onUpdate={handleLessonUpdated}
          role={role}
        />
      )}

      {showCreateModal && (
        <CreateLessonModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={handleLessonCreated}
        />
      )}
    </div>
  )
}

export default Lessons

